import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import InlineSpinner from 'components/generic/InlineSpinner.component';
import { useTheme } from 'providers/Theme.provider';
import isNotFullArray from 'utils/predicates/array/isNotFullArray.util';

import { FormRow } from 'settings/consultation-forms/list/FormRow.component';

import { FormsEmptyState } from './FormsEmptyState.component';

import CN from './FormsTable.module.scss';

export const FormsTable = ({ forms, isLoading, openTemplateModal }) => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();

  return (
    <div
      data-bem="FormsTable"
      className={cn({
        [CN.component]: true,
        [CN.darkMode]: isDarkMode,
      })}
    >
      <div className={CN.table}>
        <h3 className={CN.sectionTitle}>{t('consultationForms.yourForms')}</h3>

        <div className={CN.headerRow}>
          <div className={CN.headerCell}>{t('consultationForms.tableHeaders.formName')}</div>
          <div className={CN.headerCell}>{t('consultationForms.tableHeaders.status')}</div>
          <div className={CN.headerCell}>{t('consultationForms.tableHeaders.manage')}</div>
        </div>

        {isLoading ? (
          <div data-bem="FormsTable__spinnerContainer" className={CN.spinnerContainer}>
            <InlineSpinner variant="big" />
          </div>
        ) : isNotFullArray(forms) ? (
          <FormsEmptyState openTemplateModal={openTemplateModal} />
        ) : (
          forms.map((form) => <FormRow key={form.id} form={form} isDarkMode={isDarkMode} />)
        )}
      </div>
    </div>
  );
};
